import { ArrowRight } from "lucide-react";
import { FadeUp, Chapter } from "@/components/Reveal";

export default function Quote({ onConsult }) {
  return (
    <section
      data-testid="quote-section"
      className="border-t border-white/5 py-28 lg:py-36"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-5">
          <Chapter num="05" label="Custom Quote" />
          <FadeUp delay={0.1}>
            <h2 className="mt-8 font-serif text-4xl leading-tight tracking-[-0.02em] text-cream sm:text-5xl">
              Every Business Is Different.{" "}
              <span className="italic text-gold">So Is Every Quote.</span>
            </h2>
          </FadeUp>
        </div>
        <div className="flex flex-col justify-center lg:col-span-6 lg:col-start-7">
          <FadeUp
            delay={0.2}
            className="space-y-6 text-base leading-relaxed text-cream/60 md:text-lg"
          >
            <p>
              We don't believe in one-size-fits-all packages. Every engagement
              is scoped individually — around your goals, your market, and the
              channels that will actually move your business forward.
            </p>
            <p>
              After a short discovery call, you'll receive a tailored proposal
              with clear deliverables, timelines, and pricing. No obligation,
              no hidden fees.
            </p>
          </FadeUp>
          <FadeUp delay={0.3}>
            <button
              data-testid="quote-request-btn"
              onClick={() => onConsult()}
              className="btn-gold mt-10 self-start"
            >
              Request a Custom Quote
              <ArrowRight className="h-4 w-4" />
            </button>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
